import React from 'react';

export function MarqueeBand({ text = 'SCRATCH UNLEASHED', className = '' }) {
  const repeatedText = Array(20).fill(text).join(' • ');
  
  return (
    <div className={`marquee overflow-hidden py-3 border-y border-[var(--border-custom)] bg-[var(--surface)] ${className}`} data-testid="marquee-band">
      <div className="marquee-track font-mono text-xs tracking-[0.18em] uppercase text-[var(--text-muted)]">
        <span>{repeatedText}</span>
        <span aria-hidden="true">{repeatedText}</span>
      </div>
    </div>
  );
}